import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./LocationPermission.css";

function LocationPermission() {

  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  const allowLocation = () => {

    if (!navigator.geolocation) {

      alert("Geolocation is not supported.");

      return;

    }

    setLoading(true);

    navigator.geolocation.getCurrentPosition(

      (position) => {

        localStorage.setItem(

          "latitude",

          position.coords.latitude

        );

        localStorage.setItem(

          "longitude",

          position.coords.longitude

        );

        navigate("/onboarding/service");

      },

      () => {

        alert("Location permission denied.");

        setLoading(false);

      }

    );

  };

  const skip = () => {

    navigate("/onboarding/service");

  };

  return (

    <div className="location-page">

      <div className="location-card">

        <div className="location-icon">

          📍

        </div>

        <h1>

          Enable Location

        </h1>

        <p>

          Allow location access to discover
          <br />
          nearby Home Chefs, Restaurants,
          Hotels and Delivery Partners.

        </p>

        <div className="location-features">

          <div>🏠 Nearby Home Chefs</div>

          <div>🍽 Nearby Restaurants</div>

          <div>🚚 Faster Delivery</div>

        </div>

        <button

          className="allow-location-btn"

          onClick={allowLocation}

          disabled={loading}

        >

          {loading ? "Getting Location..." : "Allow Location"}

        </button>

        <button

          className="skip-location-btn"

          onClick={skip}

        >

          Skip

        </button>

      </div>

    </div>

  );

}

export default LocationPermission;